<template>
  <v-dialog max-width="500" :value="input">
    <v-card class="px-7 py-10">
      <CloseDialogButton :close="close" />
      <v-row no-gutters>
        <v-col class="text-center">
          <div class="font-size-lg font-weight-semibold">Remove Card?</div>
        </v-col>
      </v-row>
      <v-row class="mb-6">
        <v-col class="text-center">
          <v-icon class="mdi-credit-card-remove-outline primary--text"
            >mdi-credit-card-remove-outline</v-icon
          >
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col class="font-size-lg mb-12 mt-6 text-center">
          Are you sure you want to
          <br />remove this card?
        </v-col>
      </v-row>
      <v-row>
        <v-col class="text-center">
          <v-btn
            color="primary"
            height="48"
            width="180"
            rounded
            @click.stop="removeCreditCard"
          >
            <div class="font-size-md text-capitalize">yes</div>
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import CloseDialogButton from "@/components/UI/CloseDialogButton.vue";

export default {
  name: "RemoveCardDialog",
  components: { CloseDialogButton },
  computed: {
    ...mapState({
      dialog: (state) => state.orders.dialog.removeCard,
    }),
  },

  methods: {
    removeCreditCard() {
      this.$store.dispatch("orders/removeCreditCard", this.token);
      this.close();
    },
  },
  props: { close: Function, input: Boolean, token: String },
};
</script>

<style scoped>
.mdi-credit-card-remove-outline {
  font-size: 120px;
}
</style>
